<template>
    <span class="page-successfully-loaded-indicator"></span>
</template>

<script>
export default {
    name: "successfully-loaded",
};
</script>
